/*
 * @Author: wangshengqiang
 * @Date: 2021-12-30 11:11:46
 * @LastEditTime: 2022-01-13 18:57:49
 * @LastEditors: wangshengqiang
 * @Description: 保费算保额时 用来显示保额 使用了 SumAssured
 */
import React from 'react';
import { useStore } from '@/store';
import { Cell } from 'zarm';

const TotalSumInsured = props => {
  const {
    label
  } = props;
  const {
    totalSumInsured = '--'
  } = useStore('premium') || {};
  return /*#__PURE__*/React.createElement("div", {
    className: "form-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-item-label"
  }, /*#__PURE__*/React.createElement(Cell, {
    title: label || '保额'
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-item-control"
  }, totalSumInsured))));
};

export default TotalSumInsured;